import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AslibEnviromentModule } from '@aslib/enviroment';
import { AppComponent } from './app.component';
import { AslibModule } from '@aslib/core';
import { AslibLoadingModule } from '@aslib/loading';
import { AslibModalModule } from '@aslib/modal';
import { HomeComponent } from './home/home.component';
import { AdmPagamentoComponent } from './pagamento/adm-pagamento/adm-pagamento.component';
import { AdmParametroComponent } from './pagamento/adm-pagamento/adm-parametro.component';
import { FormsModule } from '@angular/forms';
import { AscasModule } from '@ascas/core';

import { DatePipe } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
registerLocaleData(localeBr, 'pt')

import { ParamPagamentoComponent } from './parametros/param-pagamento/param-pagamento.component';
import { ParamNotificacaoComponent } from './parametros/param-notificacao/param-notificacao.component';
import { PedidoComponent } from './pagamento/pedido/pedido.component';
import { CargaDadosComponent } from './pagamento/carga-dados/carga-dados.component';
import { ProjetoComponent } from './controle-dados/projeto/projeto.component';
import { ModalProjetoComponent } from './controle-dados/projeto/modal-projeto.component';
import { GrupoComponent } from './controle-dados/grupo/grupo.component';
import { ModalGrupoComponent } from './controle-dados/grupo/modal-grupo.component';
import { EmpenhoComponent } from './pagamento/empenho/empenho.component';
import { ProcessadoComponent } from './pagamento/empenho/processado/processado.component';
import { NaoProcessadoComponent } from './pagamento/empenho/nao-processado/nao-processado.component';
import {ProcessadoLiqComponent} from './pagamento/liq-pagamento/liq/processado/processado-liq.component';
import {NaoProcessadoLiqComponent} from './pagamento/liq-pagamento/liq/nao-processado/nao-processado-liq.component';
import {LiqComponent} from './pagamento/liq-pagamento//liq/liq.component';
import {ProcessadoLiqEmpenhoComponent} from './pagamento/liq-pagamento/liq-empenho/processado/processado-liq-empenho.component';
import {NaoProcessadoLiqEmpenhoComponent} from './pagamento/liq-pagamento//liq-empenho/nao-processado/nao-processado-liq-empenho.component';
import {LiqEmpenhoComponent} from './pagamento//liq-pagamento/liq-empenho/liq-empenho.component';
import {LiqPagamentoComponent} from './pagamento/liq-pagamento/liq-pagamento.component';
import {BaseConfig} from '../app/services/base-config.service';
import {ErrorService} from '../app/services/error.service';
import {CrudService} from '../app/services/crud.service';
import { GenericHttpService } from '../app/services/generic-http.service';
import { CpfPipe } from './shared/pipe/CpfPipe.component';
import { LiqComplementoComponent } from './pagamento/liq-pagamento/liq-complemento/liq-complemento.component';
import { RelLiquidacaoComponent } from './pagamento/relatorios/rel-liquidacao/rel-liquidacao.component';
import { FiltroRelLiquidacaoComponent } from './pagamento/relatorios/filtro-rel-liquidacao/filtro-rel-liquidacao.component';
import { NgxMaskModule } from 'ngx-mask';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { DetalheLiquidacaoComponent } from './pagamento/relatorios/detalhe-liquidacao/detalhe-liquidacao.component';
import { DetalheCargaComponent } from './pagamento/carga-dados/detalhe-carga-dados.component';
import { PedEmpLiqPipe } from './shared/pipe/ped-emp-liq.pipe';
import { CredorPipe } from './shared/pipe/credor.pipe';
import { ProcessoSeiPipe } from './shared/pipe/processo-sei.pipe';
import { SubelementoPipe } from './shared/pipe/subelemento.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AdmPagamentoComponent,
    AdmParametroComponent,
    PedidoComponent,
    ParamPagamentoComponent,
    ParamNotificacaoComponent,
    CargaDadosComponent,
    ProjetoComponent,
    ModalProjetoComponent,
    GrupoComponent,
    ModalGrupoComponent,
    EmpenhoComponent,
    ProcessadoComponent,
    NaoProcessadoComponent,
    ProcessadoLiqComponent,
    NaoProcessadoLiqComponent,
    LiqComponent, 
    ProcessadoLiqEmpenhoComponent,
    NaoProcessadoLiqEmpenhoComponent,
    LiqEmpenhoComponent,
    LiqPagamentoComponent,
    CpfPipe,
    LiqComplementoComponent,
    RelLiquidacaoComponent,
    FiltroRelLiquidacaoComponent,
    DetalheLiquidacaoComponent,
    DetalheCargaComponent,
    PedEmpLiqPipe,
    CredorPipe,
    ProcessoSeiPipe,
    SubelementoPipe
  ],
  imports: [
    CurrencyMaskModule,
    NgxMaskModule.forRoot(),
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    AslibEnviromentModule.forRoot(),
    AslibModule.forRoot({
      SiglaProjeto: 'GPA',
      CodProjeto: 'GPA',
      Descricao: 'Geração de Pagamento Automático',
      TempoSessao: 20,
         }),
    AslibLoadingModule.forRoot(),
    AscasModule.forRoot(),
    AslibModalModule.forRoot()
  ],
  providers: [
    ErrorService, GenericHttpService, BaseConfig, CrudService, DatePipe,
    { provide: LOCALE_ID, useValue: 'pt-BR' } 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts